import { oauthAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const dynamics365 = defineConnector({
  identifier: "dynamics365",
  name: "Dynamics 365",
  tagLine: "Microsoft CRM and ERP suite",
  keywords:
    "microsoft d365 crm erp dataverse power platform customer engagement",
  logo,
  protocol: "http",
  tags: ["productivity", "it"],
  defaultUrlPattern: () => "https://[^/]*\\.crm\\.dynamics\\.com/.*",
  auth: oauthAuth,
  steps: [
    {
      title: "Register an app in Microsoft Entra ID",
      items: [
        {
          kind: "markdown",
          content:
            "Create a Microsoft Entra ID app registration for the Dataverse environment you want to connect, then create a client secret for that app.",
        },
      ],
    },
    {
      title: "Create an application user in Dataverse",
      items: [
        {
          kind: "markdown",
          content:
            "In the target Dataverse environment, create an application user bound to that app registration and assign it a security role with the access you need.",
        },
      ],
    },
    {
      title: "Enter your environment and app credentials",
      items: [
        {
          kind: "url",
          label: "Environment URL",
          placeholder: "https://yourorg.crm.dynamics.com",
          required: true,
          target: { kind: "configuration", field: "environmentUrl" },
          helperText:
            "The Dataverse environment URL for the Dynamics 365 instance you want to call.",
        },
        {
          kind: "input",
          label: "Tenant ID",
          placeholder: "xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx",
          required: true,
          target: { kind: "configuration", field: "tenantId" },
          helperText: "The Microsoft Entra tenant ID for the app registration.",
        },
        {
          kind: "input",
          label: "Client ID",
          placeholder: "xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx",
          required: true,
          target: { kind: "oauthConnection", field: "clientId" },
        },
        {
          kind: "input",
          label: "Client secret",
          required: true,
          target: { kind: "oauthConnection", field: "clientSecret" },
        },
      ],
    },
  ],
  oauth: {
    grantType: () => "client_credentials",
    tokenEndpoint: ({ tenantId }) =>
      `https://login.microsoftonline.com/${tenantId}/oauth2/v2.0/token`,
    scopes: ({ environmentUrl }) => [`${environmentUrl}/.default`],
    clientCredentialsFrom: "db",
    tokenEndpointAuthMethod: () => "client_secret_post",
  },
  connectionTest: {
    protocol: "http",
    request: ({ environmentUrl }) => ({
      url: `${environmentUrl}/api/data/v9.2/WhoAmI`,
      expectedStatus: [200, 403],
    }),
  },
});
